export default __webpack_public_path__ + "static/genopets-5-c-aac81a04e45a7e5f6306f50801795a13.webp";